import type { Facet } from 'src/components/search/FilterV2/types'

export function getQuickFiltersFacet(facets: Facet[]) {
  const facetBrandDecathlon = facets?.find(
    (facet) => facet.key === '77560' || facet.key === 'marca-propria'
  )

  const facetBrandDecathlonValue = facetBrandDecathlon?.values.find(
    (value) => value.value === '77654' || value.value === 'marcas-decathlon'
  )

  const discountPixFacet = facets?.find((facet) => facet.key === 'sellername')
  const discountPixValue = discountPixFacet?.values?.find(
    (value) => value.value === 'iguasport-ltda'
  )

  const blueProductFacet = facets?.find(
    (facet) => facet.name?.toLocaleLowerCase() === 'blueproduct'
  )

  const blueProductFacetValue = blueProductFacet?.values.find(
    (value) => value.label?.toLocaleLowerCase() === 'true'
  )

  return {
    facetBrandDecathlon,
    facetBrandDecathlonValue,
    discountPixFacet,
    discountPixValue,
    blueProductFacet,
    blueProductFacetValue,
  }
}
